/**
 * WeaponDagger — short, fast blade.
 * Shorter and thinner than the sword, angled slightly outward.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponDagger() {
  return (
    <g>
      {/* Blade — short and slim */}
      <rect x="21.5" y="4"    width="1.5" height="7"   rx="0.4" fill="#d8eeff"/>
      {/* Edge highlight */}
      <rect x="21.6" y="4.5"  width="0.5" height="5.5" rx="0.2" fill="#ffffff" opacity="0.5"/>
      {/* Tiny cross-guard */}
      <rect x="20"   y="10.5" width="5"   height="1"   rx="0.4" fill="#a0b0c0"/>
      {/* Handle */}
      <rect x="21.5" y="11"   width="1.5" height="3"   rx="0.4" fill="#7a4a2a"/>
      {/* Pommel */}
      <circle cx="22.25" cy="14.5" r="0.9" fill="#5a3a2a" stroke="#9ab0c8" strokeWidth="0.4"/>
    </g>
  );
}
